var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNiceDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5C10.1266 0.5 7.80655 1.20379 5.83316 2.52236C3.85977 3.84094 2.3217 5.71509 1.41345 7.9078C0.505199 10.1005 0.267559 12.5133 0.730582 14.8411C1.1936 17.1689 2.33649 19.3071 4.01472 20.9853C5.69295 22.6635 7.83115 23.8064 10.1589 24.2694C12.4867 24.7324 14.8995 24.4948 17.0922 23.5866C19.2849 22.6783 21.1591 21.1402 22.4776 19.1668C23.7962 17.1935 24.5 14.8734 24.5 12.5C24.5 9.3174 23.2357 6.26516 20.9853 4.01472C18.7348 1.76428 15.6826 0.5 12.5 0.5ZM16.8926 6.79053C17.7342 6.79053 18.4163 7.94316 18.4163 9.36579C18.4163 10.7884 17.7342 11.9426 16.8926 11.9426C16.0511 11.9426 15.369 10.7884 15.369 9.36579C15.369 7.94316 16.0511 6.79053 16.8926 6.79053ZM8.10737 6.79053C8.94737 6.79053 9.62948 7.94316 9.62948 9.36579C9.62948 10.7884 8.94737 11.9426 8.10737 11.9426C7.26737 11.9426 6.58369 10.7884 6.58369 9.36579C6.58369 7.94316 7.2658 6.79053 8.10737 6.79053ZM19.4142 15.4021C18.9105 18.2774 16.0763 20.2716 12.6579 20.2716C9.23948 20.2716 6.40369 18.2774 5.90001 15.4021C5.8951 15.3729 5.89246 15.3433 5.89211 15.3137C5.89211 14.8984 6.3958 14.63 6.83948 14.7816C8.54316 15.3705 10.5326 15.6705 12.6579 15.6705C14.7832 15.6705 16.7711 15.3705 18.4779 14.7816C18.9184 14.6237 19.4253 14.8968 19.4253 15.3137C19.4239 15.3434 19.4202 15.373 19.4142 15.4021Z",
    fill: "url(#paint0_linear_6184_15183)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6184_15183",
    x1: 12.5,
    y1: 0.5,
    x2: 12.5,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiceDay);
export default __webpack_public_path__ + "static/media/niceDay.cf24a361b488e8fedc9e0d2ee5e7cf96.svg";
export { ForwardRef as ReactComponent };